// extracted by mini-css-extract-plugin
export default {"wrapper":"Np-z","response":"Op-z","error":"Pp-z","disabled":"Qp-z","buttons":"Rp-z","feedbackQuestionSection":"Sp-z","yesNoWrapper":"Tp-z"};